import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Card, CardBody, Button, CardTitle, CardSubtitle, Modal, ModalBody } from "reactstrap"
import { connect } from "react-redux"
import { withRouter, useParams, useLocation } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb";
// import Utils from '../Utility';
import Utils from '../Utility';
import Loader from "../../components/Loader";
import DataTable from 'react-data-table-component';
import { get, put } from '../../helpers/api_helper'
import { toast } from 'react-toastify';
// import DeleteModal from './DeleteModal';
import DeleteModal from '../../components/ConfirmModal/DeleteModal';
import moment from 'moment'
import { AvField, AvForm } from 'availity-reactstrap-validation'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';


const HourlytechjobsContactus = props => {
    const { user } = props;
    const [currentData, setCurrentData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modal, setModal] = useState(false);
    const formRef = useRef();


    useEffect(() => {
        if (user?.token)
            getData();
    }, [user]);

    const getData = () => {
        if (!loading) {
            setLoading(true);
            get("/contact/hourlytech", { token: user?.token })
                .then(res => {
                    setLoading(false);
                    if (res?.statusCode == 200) {
                        setData(res?.data);
                    } else {
                        toast.error(res?.error);
                    }
                })
                .catch(err => {
                    setLoading(false);
                    console.log('error while getting enquiries', err);
                    toast.error('Something Went Wrong!');
                })
        }
    }

    useEffect(() => {
        setColumns([
            {
                name: 'Sl.No',
                cell: (row, index) => <>
                    <span>{index + 1}</span>
                </>,
                // maxWidth: '80px'
            },
            {
                name: 'Name',
                selector: row => row?.name,
                cell: (row) => <div>
                    <span style={{ textTransform: 'capitalize', marginLeft: 5 }}>{row?.name}</span>
                </div>,
                sortable: true,
                // maxWidth: '295px',
                minWidth: '100px'
            },
            {
                name: 'Email',
                selector: row => row?.email,
                sortable: true,
                // maxWidth: '210px',
                minWidth: '100px'
            },
            {
                name: 'Mobile',
                selector: row => row?.mobile,
                sortable: true,
                // maxWidth: '210px',
                minWidth: '100px'
            },
            // {
            //     name: 'Message',
            //     cell: (row) => <>
            //         <span title={row?.message}>{row?.message?.length > 50 ? row?.message.substring(0, 50) + "..." : row?.message}</span>
            //     </>,
            //     selector: row => row?.message,
            //     sortable: true
            // },
            {
                name: 'Created At',
                selector: row => moment(row?.createdAt).format("DD-MMM-YYYY"),
                sortable: true,
                // maxWidth: '200px'
                minWidth: '100px'
            },
            // {
            //     cell: (row) => <>
            //         <Button onClick={() => handleUpdateStatus(row)}
            //             title={row?.isActive ? "Completed" : "Pending"}
            //             style={{ backgroundColor: !row.isActive ? 'green' : 'orange', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            //             <span className="text-white" style={{}}>
            //                 {!row?.isActive ? 'Completed' : 'Pending'}
            //             </span>
            //         </Button>
            //     </>,
            //     name: 'Status',
            //     ignoreRowClick: true,
            //     maxWidth: '130px'
            // },
            {
                cell: (row) => <>
                    {/* <Button onClick={() => handleUpdateProj(row)}
                        title={"Reply"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-comment" style={{ fontSize: 20 }}></span></Button> */}
                    <Button onClick={() => handleDeleteProj(row)}
                        title={"Delete"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
                </>,
                name: 'Action',
                ignoreRowClick: true,
                maxWidth: '80px'
            },
        ]);
    }, [data]);

    const handleUpdateStatus = (row) => {
        setCurrentData({ ...row, actionType: 'Status' });
        setDeleteModal(true);
    }

    const handleDeleteProj = (row) => {
        setCurrentData({ ...row, actionType: "Delete" });
        setDeleteModal(true);
    }

    const handleUpdateProj = (row) => {
        setCurrentData(row);
        setModal(true);
    }

    const onDelete = () => {
        setLoading(true);
        let body = {
            contactId: currentData?._id,
            type: "Hourly",
            token: user?.token
        }
        if (currentData?.actionType == 'Status')
            body = { ...body, isActive: !currentData?.isActive }
        else
            body = { ...body, isDeleted: true }
        put("/contact/", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    getData();
                    setDeleteModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const handleValidSubmit = (e, v) => {
        let body = {
            contactId: currentData?._id,
            reply: v?.reply,
            isActive: false,
            token: user?.token
        }
        put("/contact/", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    getData();
                    setModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const ExpandedComponent = ({ data }) =>
        <div className='expending_box'>
            <Row>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <h5><b>Email : </b></h5>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <p>{data?.email}</p>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <h5><b>Mobile : </b></h5>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <p>{data?.mobile}</p>
                    </div>
                </Col>
                <Col lg={1}>
                    <div className='expend_detail'>
                        <h5><b>Message : </b></h5>
                    </div>
                </Col>
                <Col lg={11}>
                    <div className='expend_detail'>
                        <p>{data?.message}</p>
                    </div>
                </Col>
            </Row>
        </div>


    return (
        <React.Fragment>
            <div className="page-content">
                <Loader visible={loading} />
                <Breadcrumb title={Utils.projectName} breadcrumbItem="Contact Us" />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={() => onDelete()}
                    onCloseClick={() => setDeleteModal(false)}
                    data={currentData}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <CardTitle className="h4">Contact Us</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Inquiries those who filled the contact us form, All the <code>Users will not be able </code> to fill that form again until you don't <code>Completed</code> that <code>Iquiry.</code>
                                </CardSubtitle> */}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className='mb-4 px-3'>
                                    <AvForm onValidSubmit={getData} ref={formRef}>
                                        <Row className='mt-2'>
                                            <Col md={9}>
                                                <AvField
                                                    name="search"
                                                    placeholder="Search contact by name, email, mobile no."
                                                />
                                            </Col>
                                            <Col md={1}>
                                                <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor, float: 'right' }} className="btn btn-sign">{currentData?._id ? 'Search' : 'Search'}</button>
                                            </Col>
                                            <Col md={2}>
                                                <button type="reset" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}
                                                    onClick={() => { formRef?.current?.reset(); getData(); }}
                                                    className="btn btn-sign" >Clear Filter</button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </div>
                            </Col>
                        </Row>

                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            expandableRows={true}
                            expandOnRowClicked={false}
                            expandableRowDisabled={row => row.disabled}
                            expandableRowsComponent={ExpandedComponent}
                            expandableRowsComponentProps={row => row.Action}
                            customStyles={{
                                headCells: {
                                    style: {
                                        color: 'black',
                                        fontWeight: 'bold',
                                        fontSize: 15,
                                        maxWidth: 80
                                    },
                                },
                                cells: {
                                    style: {
                                        maxWidth: 50
                                    }
                                }
                            }}
                            conditionalRowStyles={[{
                                when: row => row?.seen?.length < 1,
                                style: { backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: 'white', cursor: 'pointer' },
                            }]}
                        // onRowClicked={(r, e) => seenNoti(r)}
                        />

                    </CardBody>
                </Card>
                {/* <Modal className="modal_form" isOpen={modal} toggle={() => { setModal(false) }} centered={true}>
                    <ModalBody className="py-3 px-5">
                        <h5 className="text-black font-size-20">{'User Contact Us'}</h5>
                        <div className="p-2">
                            <Row>
                                <Col md={12}>
                                    <span>User -<span><b> {currentData?.name}</b></span></span>
                                </Col>
                                <Col md={10}>
                                    <span>Email -<span><b> {currentData?.email}</b></span></span>
                                </Col>
                                <Col md={10} className='mb-2'>
                                    <span>Mobile -<span><b> {currentData?.user?.mobile}</b></span></span>
                                </Col>
                                <hr></hr>
                                <Col md={10}>
                                    <span><span><b> {currentData?.message}</b></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className="p-2">
                            <AvForm
                                className="form-horizontal"
                                onValidSubmit={(e, v) => {
                                    handleValidSubmit(e, v)
                                }}
                            >
                                <Row>
                                    <Col lg={12} md={12}>
                                        <div className="mt-4">
                                            <AvField
                                                type="textarea"
                                                rows={5}
                                                name="reply"
                                                label="Reply"
                                                placeholder={"Provide your detailed response or answer to the user's Contact here."}
                                                value={currentData?.reply}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={12} md={12}>
                                        <div className="mt-4">
                                            <Row>
                                                <Col md={6}>
                                                    <button
                                                        className="btn btn-primary w-100 waves-effect waves-light"
                                                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                        onClick={() => { setModal(false) }}
                                                        type="reset"
                                                    >
                                                        Cancel
                                                    </button>
                                                </Col>
                                                <Col md={6}>
                                                    <button
                                                        className="btn btn-primary w-100 waves-effect waves-light"
                                                        type="submit"
                                                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                    >
                                                        {currentData?.reply ? 'Update' : 'Reply'}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </AvForm>
                        </div>
                    </ModalBody>
                </Modal> */}
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    return { user }
}

export default withRouter(
    connect(mapStatetoProps, {})(HourlytechjobsContactus)
)
